import { defineMessages } from 'react-intl';

export default defineMessages({
  pending: { defaultMessage: 'Pending' },
  confirmed: { defaultMessage: 'Confirmed' },
  failed: { defaultMessage: 'Failed' },
  error: { defaultMessage: 'Error' },
});
